import axiosInstance from "./axiosInstance";

export const fetchPaymentSettings = (customerId) =>
  axiosInstance.get("/superadmin/payment-settings", {
    params: { customer_id: customerId },
  });

export const updatePaymentSettings = (data) => axiosInstance.put("/superadmin/payment-settings", data);

export const fetchPaymentMaintenance = () => axiosInstance.get("/superadmin/payment-settings/maintenance");

export const updatePaymentMaintenance = (data) => axiosInstance.put("/superadmin/payment-settings/maintenance", data);
export const fetchPlatformBillingSettings = () => axiosInstance.get("/superadmin/payment-settings/platform-billing");
export const updatePlatformBillingSettings = (data) => axiosInstance.put("/superadmin/payment-settings/platform-billing", data);
